import $ from 'jquery';
import EFOcats_event_core from './efocats_event_core.js';

/**
 * Androidのソフトウェアキーボード出現時に要素が隠れないようにする
 */
export default class EFOcats_event_androidkeybord extends EFOcats_event_core {
  /**
   * イベント本体をセット
   */
  event() {
    const ua = window.navigator.userAgent.toLowerCase();

    // androidだけ
    if (ua.indexOf('android') !== -1 && ua.indexOf('mobile') !== -1) {
      this.winHeight = 0;

      // キーボードの出現に応じて画面をリサイズ
      this.resize();

      // 入力欄でEnterしたらtabindex遷移する
      this.keydown_enter();
    }
  }

  /**
   * 入力欄でEnterしたらtabindex遷移する
   */
  keydown_enter() {
    this.$('input').on('keydown', event => {
      if (event.which === 13) {
        const element = event.currentTarget;
        if ($(element).attr('tabindex') && $(element).attr('tabindex') > 0) {
          const nextInput = Number($(element).attr('tabindex')) + 1;
          if ($(element).parents('.qa').find(`[tabindex="${nextInput}"]`).length > 0) {
            const focusItem = $(element).parents('.qa').find(`[tabindex="${nextInput}"]`).first();

            if (!focusItem.attr('readonly') && !['checkbox', 'radio', undefined].includes(focusItem.attr('type'))) {
              focusItem.trigger('focus');
              this.move(focusItem);
            } else {
              $(element).trigger('blur');
            }
          } else {
            $(element).trigger('blur');
          }
        } else {
          $(element).trigger('blur');
        }
      }
    });
  }

  /**
   * キーボード表示/非表示のイベント起動
   */
  resize() {
    const iframewin = document.getElementsByClassName('efocats_frame')[0].contentWindow;

    $(iframewin).on('resize', event => {
      if (this.winHeight < $(iframewin).height()) {
        this.winHeight = $(iframewin).height();
      }

      if (this.winHeight > $(iframewin).height()) {
        const focusItem = this.$(':focus');

        if (focusItem.prop('tagName') !== 'INPUT' || !['text', 'tel', 'email', 'password'].includes(focusItem.attr('type'))) {
          return;
        }

        this.move(focusItem);
      } else {
        this.$('.action')[0].scrollIntoView();
      }
    });
  }

  /**
   * 遷移
   * @param {*}} focusItem
   */
  move(focusItem) {
    if (focusItem.parent().prev('.cat-txt-design').length > 0) {
      focusItem.parent().prev('.cat-txt-design')[0].scrollIntoView();
    } else if (focusItem.parents('.inner').prev().prev('.cat-txt-design').length > 0) {
      focusItem.parents('.inner').prev().prev('.cat-txt-design')[0].scrollIntoView();
    }
  }
}
